import { render, staticRenderFns } from "./secondaryPagesHDXX.vue?vue&type=template&id=3a2a9793&scoped=true&"
import script from "./secondaryPagesHDXX.vue?vue&type=script&lang=js&"
export * from "./secondaryPagesHDXX.vue?vue&type=script&lang=js&"
import style0 from "./secondaryPagesHDXX.vue?vue&type=style&index=0&id=3a2a9793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a9793",
  null
  
)

export default component.exports